export default {
  zh: {
    'brand.name': '和氏币',
    'hero.pause': '暂停首屏动效',
    'hero.resume': '播放首屏动效',
    'nav.home': '和氏币 HS 首页',
    'nav.lang': '切换语言',
    'nav.menu': '页面导航',
    'nav.buy': '参与认购',
    'nav.dashboard': '数据中心',
    'nav.team': '推荐团队',
    'nav.trust': '规则与合约',
    'nav.connect': '连接钱包',
    'wallet.current': '当前钱包',
    'wallet.balance': '钱包余额',
    'wallet.copy': '复制地址',
    'wallet.address': '钱包地址',
    'wallet.disconnect': '断开钱包',
    'wallet.disconnected': '钱包已断开',
    'hero.title': '和氏币 HS',
    'hero.subtitle': '席位认购计划',
    'hero.tagline': '链上公开 · 规则透明 · 席位有限',
    'buy.title': '选择认购席位',
    'buy.live': '进行中',
    'buy.ended': '已结束',
    'buy.gas': 'Gas 预估',
    'buy.referrer': '邀请人',
    'buy.confirmed': '已确认',
    'buy.pending': '待确认',
    'buy.confirming': '链上确认中…',
    'buy.checking': '正在检测链上入金状态…',
    'buy.completed': '当前钱包已完成认购',
    'buy.retryCheck': '重新检测后认购',
    'buy.cta': '认购 {amount} BNB',
    'buy.connectCta': '连接钱包参与认购',
    'buy.endedCta': '预售已结束',
    'buy.note': '每个钱包仅可认购一次 · 同等金额按链上确认时间排序',
    'buy.endedNote': '本次预售已结束，暂不支持新的认购',
    'seat.bronze': '青铜席',
    'seat.silver': '白银席',
    'seat.gold': '黄金席',
    'dash.title': '我的累计数据',
    'dash.sync': '链上同步',
    'dash.performance': '我的认购',
    'dash.directPerf': '直推累计业绩',
    'dash.teamPerf': '团队累计业绩',
    'dash.shareTeamPerf': '分享团队总业绩',
    'dash.shareTeamNote': '真实邀请网体所有下级累计认购，不含本人',
    'dash.teamCount': '团队累计人数',
    'dash.people': ' 人',
    'dash.directOf': '其中直推 {count} 人',
    'dash.nft': 'NFT 持仓数量',
    'dash.nftUnit': ' 枚',
    'dash.nftNote': '直推业绩达标后由合约铸造',
    'dash.reward': '推荐奖励优先实时到账，转账失败的奖励保留在合约中待领取',
    'invite.title': '我的邀请链接',
    'invite.desc': '好友通过链接完成绑定后，将自动进入你的直推团队。',
    'invite.placeholder': '连接钱包后生成专属邀请链接',
    'invite.link': '邀请链接',
    'share.title': '排名团队',
    'share.chip': '共 {count} 人',
    'share.myRank': '我的排名 #{rank}',
    'share.noRank': '认购后生成排名',
    'share.connectTitle': '连接钱包查看排名团队',
    'share.connectHint': '排名比你靠后的已认购地址将显示在这里',
    'share.loading': '正在同步分享列表',
    'share.emptyTitle': '暂无排名在你之后的团队成员',
    'share.emptyHint': '完成认购并获得排名后，排队在你后面的地址会出现在这里',
    'share.rank': '排名 #{rank}',
    'team.title': '我的直推',
    'team.directCount': '直推 {count} 人',
    'team.connectTitle': '连接钱包查看推荐关系',
    'team.connectHint': '团队数据由链上绑定事件同步',
    'team.loading': '正在同步团队数据',
    'team.emptyTitle': '还没有直推成员',
    'team.emptyHint': '复制邀请链接，邀请伙伴加入',
    'team.loadingSecond': '正在读取第二层关系…',
    'team.noSecond': '该成员暂无直推',
    'trust.title': '规则与链上信任',
    'trust.ruleTitle': '认购金额越高，排序越靠前',
    'trust.ruleDesc': '金额相同时，以链上确认时间较早者优先。所有排序依据均来自不可篡改的区块记录。',
    'trust.network': '网络',
    'trust.audit': '合约审计材料',
    'trust.viewCode': '查看源码',
    'trust.fund': '资金流向',
    'trust.fundValue': '链上透明',
    'trust.rule': '执行规则',
    'trust.ruleValue': '合约不可篡改',
    'trust.copy': '复制',
    'trust.contract': '合约地址',
    'trust.viewContract': '在区块浏览器查看合约',
    'footer.risk': '数字资产具有风险，请在充分了解规则后参与链上交互',
    'faq.q1': '如何获得排队序号？',
    'faq.a1': '完成任一档位认购并等待链上确认后，系统会按累计认购金额和首次确认时间自动生成序号。',
    'faq.q2': '认购前为什么需要绑定邀请人？',
    'faq.a2': '推荐关系由智能合约永久记录。首次参与的钱包需要通过有效邀请链接完成一次链上绑定。',
    'faq.q3': '推荐奖励如何领取？',
    'faq.a3': '已认购的直接推荐人获得 10% BNB 奖励。合约优先实时转账，失败后可由推荐人调用 claimReferralReward 领取到指定地址。',
    'faq.q4': '交易数据多久更新？',
    'faq.a4': '后端会等待安全确认区块后同步数据，因此页面展示可能比钱包交易成功稍晚。链上记录始终是最终依据。',
    'modal.title': '确认邀请人地址',
    'modal.desc': '邀请关系写入链上后无法修改，请核对或调整下方地址。',
    'modal.label': '邀请人钱包地址',
    'modal.clear': '清空地址',
    'modal.close': '关闭',
    'modal.fromLink': '已从邀请链接识别，可在确认前修改',
    'modal.needAddress': '请输入有效的 BNB Chain 钱包地址',
    'modal.bindTitle': '链上永久绑定',
    'modal.bindDesc': '确认后将单独发起绑定交易；绑定成功后钱包才会进入已连接状态。',
    'modal.cancel': '取消连接',
    'modal.confirming': '绑定确认中…',
    'modal.confirm': '确认并绑定',
    'modal.success': '邀请关系绑定成功，钱包已连接',
    'copy.action': '复制',
    'copy.done': '已复制',
    'copy.manual': '长按复制',
    'copy.copied': '{label}已复制',
    'copy.missing': '{label}尚未配置',
    'copy.fail': '自动复制失败，请长按内容复制',
    'buy.success': '认购成功，等待安全区块确认',
    'common.pending': '待配置',
    'common.incomplete': '操作未完成',
    'lang.zh': '中文',
    'lang.en': 'English',
    'error.invalidAddress': '请输入有效的钱包地址',
    'error.selfReferrer': '邀请人不能是当前钱包',
    'error.needWeb3': '请在支持 Web3 的钱包浏览器中打开',
    'error.noAccount': '未获取到钱包账户',
    'error.wrongNetwork': '请切换到正确网络（Chain ID {chainId}）',
    'error.bindStatus': '暂时无法读取链上绑定状态',
    'error.reconnect': '请重新连接钱包',
    'error.confirmReferrer': '请先确认邀请人地址',
    'error.noContract': 'IDO 合约地址尚未配置',
    'error.bindFirst': '请先连接并绑定钱包',
    'error.notBound': '当前钱包尚未绑定邀请关系',
    'error.purchaseStatus': '暂时无法读取链上入金状态，请稍后重试',
    'error.alreadyPurchased': '当前钱包已经入金，不能重复认购',
    'error.saleEnded': '预售已结束，无法继续认购',
    'error.apiUnavailable': '数据服务暂不可用',
    'error.indexerNotConfigured': 'Sale 数据索引尚未配置',
    'error.indexerContractMismatch': '数据索引与 Sale 合约地址不一致',
    'data.loading': '正在加载入金数据',
    'data.retry': '重试',
    'data.rank': '排名',
    'data.address': '地址',
    'data.amount': '入金金额',
    'data.previous': '上一页',
    'data.next': '下一页',
    'doc.title': '和氏币 HS · 预售',
    'doc.description': '和氏币 HS 链上预售与团队中心',
  },
  en: {
    'brand.name': 'HS',
    'hero.pause': 'Pause hero animation',
    'hero.resume': 'Play hero animation',
    'nav.home': 'HS Home',
    'nav.lang': 'Language',
    'nav.menu': 'Menu',
    'nav.buy': 'Join Sale',
    'nav.dashboard': 'Dashboard',
    'nav.team': 'Team',
    'nav.trust': 'Rules & Contract',
    'nav.connect': 'Connect Wallet',
    'wallet.current': 'Current Wallet',
    'wallet.balance': 'Balance',
    'wallet.copy': 'Copy Address',
    'wallet.address': 'Wallet address',
    'wallet.disconnect': 'Disconnect',
    'wallet.disconnected': 'Wallet disconnected',
    'hero.title': 'HS',
    'hero.subtitle': 'Seat Allocation Sale',
    'hero.tagline': 'On-chain · Transparent · Limited Seats',
    'buy.title': 'Select a Seat',
    'buy.live': 'Live',
    'buy.ended': 'Ended',
    'buy.gas': 'Est. Gas',
    'buy.referrer': 'Referrer',
    'buy.confirmed': 'Confirmed',
    'buy.pending': 'Pending',
    'buy.confirming': 'Confirming…',
    'buy.checking': 'Checking on-chain purchase status…',
    'buy.completed': 'Purchase already completed',
    'buy.retryCheck': 'Recheck & Buy',
    'buy.cta': 'Buy {amount} BNB',
    'buy.connectCta': 'Connect Wallet to Buy',
    'buy.endedCta': 'Sale Ended',
    'buy.note': 'One purchase per wallet · Same amount ranks by confirmation time',
    'buy.endedNote': 'This pre-sale has ended. New purchases are no longer available',
    'seat.bronze': 'Bronze',
    'seat.silver': 'Silver',
    'seat.gold': 'Gold',
    'dash.title': 'My Stats',
    'dash.sync': 'On-chain Sync',
    'dash.performance': 'My Total Purchase',
    'dash.directPerf': 'Direct Performance',
    'dash.teamPerf': 'Team Performance',
    'dash.shareTeamPerf': 'Referral Team Total Performance',
    'dash.shareTeamNote': 'Total purchases by all referral descendants, excluding yourself',
    'dash.teamCount': 'Team Size',
    'dash.people': '',
    'dash.directOf': '{count} direct referrals',
    'dash.nft': 'NFT Holdings',
    'dash.nftUnit': '',
    'dash.nftNote': 'Minted when direct performance reaches the threshold',
    'dash.reward': 'Rewards are paid immediately when possible; failed transfers remain available to claim.',
    'invite.title': 'My Invite Link',
    'invite.desc': 'Friends who bind via your link join your direct team automatically.',
    'invite.placeholder': 'Connect wallet to generate your invite link',
    'invite.link': 'Invite link',
    'share.title': 'My Team',
    'share.chip': '{count} total',
    'share.myRank': 'My rank #{rank}',
    'share.noRank': 'Rank after purchase',
    'share.connectTitle': 'Connect wallet to view my team',
    'share.connectHint': 'Purchasers ranked behind you will appear here',
    'share.loading': 'Syncing share list…',
    'share.emptyTitle': 'No team members ranked behind you yet',
    'share.emptyHint': 'After you purchase and get a rank, addresses behind you will show here',
    'share.rank': 'Rank #{rank}',
    'team.title': 'My Referrals',
    'team.directCount': '{count} Direct',
    'team.connectTitle': 'Connect wallet to view referrals',
    'team.connectHint': 'Team data syncs from on-chain bind events',
    'team.loading': 'Syncing team data…',
    'team.emptyTitle': 'No direct referrals yet',
    'team.emptyHint': 'Copy your invite link and share it',
    'team.loadingSecond': 'Loading second level…',
    'team.noSecond': 'No direct referrals under this member',
    'trust.title': 'Rules & Trust',
    'trust.ruleTitle': 'Higher amount ranks higher',
    'trust.ruleDesc': 'If amounts match, earlier on-chain confirmation wins. Ranking is based on immutable block data.',
    'trust.network': 'Network',
    'trust.audit': 'Audit Materials',
    'trust.viewCode': 'View Source',
    'trust.fund': 'Fund Flow',
    'trust.fundValue': 'On-chain Transparent',
    'trust.rule': 'Execution',
    'trust.ruleValue': 'Immutable Contract',
    'trust.copy': 'Copy',
    'trust.contract': 'Contract address',
    'trust.viewContract': 'View contract on explorer',
    'footer.risk': 'Digital assets involve risk. Participate only after understanding the rules.',
    'faq.q1': 'How do I get a queue number?',
    'faq.a1': 'After any seat purchase is confirmed on-chain, the system ranks you by total purchase amount and first confirmation time.',
    'faq.q2': 'Why bind a referrer first?',
    'faq.a2': 'Referral relationships are permanently recorded by the contract. First-time wallets must complete one on-chain bind via a valid invite.',
    'faq.q3': 'How do I claim referral rewards?',
    'faq.a3': 'Direct referrers who have purchased receive 10% in BNB. Failed transfers remain claimable to a chosen address through claimReferralReward.',
    'faq.q4': 'How soon does data update?',
    'faq.a4': 'The backend waits for safe confirmation blocks, so the UI may lag wallet success slightly. On-chain records are final.',
    'modal.title': 'Confirm Referrer',
    'modal.desc': 'Referral binding is permanent on-chain. Please verify or edit the address below.',
    'modal.label': 'Referrer wallet address',
    'modal.clear': 'Clear address',
    'modal.close': 'Close',
    'modal.fromLink': 'Detected from invite link — editable before confirm',
    'modal.needAddress': 'Enter a valid BNB Chain wallet address',
    'modal.bindTitle': 'Permanent on-chain bind',
    'modal.bindDesc': 'Confirming sends a separate bind transaction. Your wallet connects only after it succeeds.',
    'modal.cancel': 'Cancel',
    'modal.confirming': 'Binding…',
    'modal.confirm': 'Confirm & Bind',
    'modal.success': 'Referrer bound — wallet connected',
    'copy.action': 'Copy',
    'copy.done': 'Copied',
    'copy.manual': 'Long-press',
    'copy.copied': '{label} copied',
    'copy.missing': '{label} not configured',
    'copy.fail': 'Auto-copy failed — long-press to copy',
    'buy.success': 'Purchase submitted — waiting for safe confirmation',
    'common.pending': 'Pending',
    'common.incomplete': 'Action incomplete',
    'lang.zh': '中文',
    'lang.en': 'English',
    'error.invalidAddress': 'Enter a valid wallet address',
    'error.selfReferrer': 'Referrer cannot be your own wallet',
    'error.needWeb3': 'Open this page in a Web3 wallet browser',
    'error.noAccount': 'No wallet account found',
    'error.wrongNetwork': 'Switch to the correct network (Chain ID {chainId})',
    'error.bindStatus': 'Unable to read on-chain bind status',
    'error.reconnect': 'Please reconnect your wallet',
    'error.confirmReferrer': 'Confirm the referrer address first',
    'error.noContract': 'IDO contract address is not configured',
    'error.bindFirst': 'Connect and bind your wallet first',
    'error.notBound': 'This wallet has not bound a referral yet',
    'error.purchaseStatus': 'Unable to read on-chain purchase status. Please try again',
    'error.alreadyPurchased': 'This wallet has already purchased and cannot purchase again',
    'error.saleEnded': 'The pre-sale has ended. Purchases are closed',
    'error.apiUnavailable': 'Data service temporarily unavailable',
    'error.indexerNotConfigured': 'Sale data index is not configured',
    'error.indexerContractMismatch': 'Data index does not match the Sale contract',
    'data.loading': 'Loading deposits',
    'data.retry': 'Retry',
    'data.rank': 'Rank',
    'data.address': 'Address',
    'data.amount': 'Deposited',
    'data.previous': 'Previous page',
    'data.next': 'Next page',
    'doc.title': 'HS · Presale',
    'doc.description': 'HS on-chain presale and team hub',
  },
}
